import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";
import { Card } from "./ui/card";

interface PageHeaderProps {
    icon: LucideIcon;
    title: string;
    description: string;
    action?: ReactNode;
}

export function PageHeader({ icon: Icon, title, description, action }: PageHeaderProps) {
    return (
        <Card className="glass-card border-none overflow-hidden">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4 sm:px-6 py-2">
                <div className="flex items-center gap-2 sm:gap-3 mb-1 mt-3 sm:mb-2 ">
                    <div className="p-1.5 sm:p-2 bg-primary/10 rounded-lg shrink-0">
                        <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                    </div>
                    <h4 className="text-2xl sm:text-2xl font-bold truncate">{title}</h4>
                </div>
                {/* <p className="text-sm sm:text-base text-muted-foreground">{description}</p> */}
                {action && <div className="shrink-0">{action}</div>}
            </div>
        </Card>
    );
}
/*
<Card className="glass-card overflow-hidden">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 sm:p-6 border-b">
                    <h3 className="text-base sm:text-lg font-semibold">Profile Information</h3>
*/